import { render, staticRenderFns } from "./investmentProofs.vue?vue&type=template&id=34d7ecd4&scoped=true"
import script from "./investmentProofs.vue?vue&type=script&lang=js"
export * from "./investmentProofs.vue?vue&type=script&lang=js"
import style0 from "./investmentProofs.vue?vue&type=style&index=0&id=34d7ecd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d7ecd4",
  null
  
)

export default component.exports